export default "__VITE_ASSET__qK9urNke__"